export default __webpack_public_path__ + "static/media/good.eddeaacb.png";